import { useState, useEffect } from 'react';

export const useServiceRequests = (socket, user) => {
  const [newServiceRequests, setNewServiceRequests] = useState([]);
  const [counterOffers, setCounterOffers] = useState([]);
  const [expiredRequests, setExpiredRequests] = useState([]);
  const [expiredOffers, setExpiredOffers] = useState([]);
  const [noProvidersFound, setNoProvidersFound] = useState(null);

  useEffect(() => {
    if (!socket) return;

    const handleNewServiceRequest = (requestData) => {
      console.log('🔔 ===== NEW SERVICE REQUEST RECEIVED =====');
      console.log('📋 Request Data:', JSON.stringify(requestData, null, 2));
      console.log('⏰ Expiry Time:', requestData.expiryTime);

      setNewServiceRequests((prev) => {
        const idToCheck = requestData.serviceRequestId || requestData.requestId;
        const index = prev.findIndex(
          (req) => (req.serviceRequestId || req.requestId) === idToCheck
        );

        if (index !== -1) {
          console.log('♻️ Existing request found, updating data:', idToCheck);
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            ...requestData,
            expiryTime: requestData.expiryTime,
            receivedAt: new Date(),
          };
          return updated;
        }

        const updated = [
          ...prev,
          { ...requestData, expiryTime: requestData.expiryTime, receivedAt: new Date() },
        ];
        console.log('✅ Added to requests. New count:', updated.length);
        return updated;
      });
    };

    const handleCounterOffer = (counterOfferData) => {
      console.log('📋 Counter Offer Data:', JSON.stringify(counterOfferData, null, 2));

      setCounterOffers((prev) => {
        const exists = prev.find((offer) => offer.offerId === counterOfferData.offerId);
        if (exists) {
          return prev;
        }
        return [...prev, { ...counterOfferData, receivedAt: new Date() }];
      });
    };

    const handleNoProviders = (data) => {
      setNoProvidersFound(data);
    };

    socket.on('newServiceRequest', handleNewServiceRequest);
    socket.on('counterOffer', handleCounterOffer);
    socket.on('service:no-providers', handleNoProviders);

    return () => {
      socket.off('newServiceRequest', handleNewServiceRequest);
      socket.off('counterOffer', handleCounterOffer);
      socket.off('service:no-providers', handleNoProviders);
    };
  }, [socket]);

  const acceptServiceRequest = (requestId) => {
    const roleName = user?.role?.name || user?.role;
    if (socket && roleName === 'handyman') {
      socket.emit('handyman:accept-request', {
        requestId,
        handymanId: user._id,
      });

      setNewServiceRequests((prev) =>
        prev.filter((req) => req.requestId !== requestId)
      );

      console.log(`💰 Accepted service request: ${requestId}`);
    }
  };

  return {
    newServiceRequests,
    setNewServiceRequests,
    counterOffers,
    setCounterOffers,
    expiredRequests,
    expiredOffers,
    setExpiredRequests,
    setExpiredOffers,
    noProvidersFound,
    setNoProvidersFound,
    acceptServiceRequest,
  };
};
